import angular from 'angular';
import ngResource from 'angular-resource';
import ngRoute from 'angular-route';
import ngCookies from 'angular-cookies';
import ngAnimate from 'angular-animate';
import uiValidate from "../../lib/ui-validate";
import AppService from "./services";
import UserService from "./user/services";
import controllers from "./user/controllers";

let mainApp = angular.module('user', [ngResource, ngRoute, ngCookies, ngAnimate, AppService, UserService, uiValidate]);

mainApp
    .controller('MainCtrl', controllers.MainCtrl)
    .controller('AlertBoxCtrl', controllers.AlertBoxCtrl)
    .controller('UserProfileEditCtrl', controllers.UserProfileEditCtrl)
    .controller('UserCreateCtrl', controllers.UserCreateCtrl)
    .controller('ResetPasswordCtrl', controllers.ResetPasswordCtrl)
    .controller('LoginCtrl', controllers.LoginCtrl);

angular.bootstrap(document, [ 'user' ]);


// WEBPACK FOOTER //
// ./js/legacy/app/main.js